import { motion } from "framer-motion";

export const IMG = {
  hero: "/assets/hero-tecnico.jpg",
  fogao: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=800&q=80",
  aquecedor: "https://images.unsplash.com/photo-1585704032915-c3400ca199e7?auto=format&fit=crop&w=800&q=80",
  estanqueidade: "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?auto=format&fit=crop&w=800&q=80",
  tubulacao: "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=800&q=80",
  laudos: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&w=800&q=80",
  manutencao: "https://images.unsplash.com/photo-1621905252507-b35492cc74b4?auto=format&fit=crop&w=800&q=80",
  about: "https://images.unsplash.com/photo-1516937941344-00b4e0337589?auto=format&fit=crop&w=800&q=80",
};

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ num, title, accent, dark = false }) => (
  <Reveal className="mx-auto mb-14 max-w-3xl text-center">
    <span
      data-testid={`chapter-${num}-label`}
      className="font-display text-sm font-bold uppercase tracking-[0.35em] text-[var(--primary)]"
    >
      {num}
    </span>
    <h2
      className={`mt-3 font-display text-4xl font-bold uppercase leading-[0.95] sm:text-5xl ${
        dark ? "text-white" : "text-zinc-900"
      }`}
    >
      {title}{" "}
      <span className="italic text-[var(--primary)]">{accent}</span>
    </h2>
  </Reveal>
);

export const Logo = () => (
  <a href="/" data-testid="logo-link" className="flex select-none items-center gap-2.5">
    <span className="logo-flame" data-testid="logo-flame-image">
      <img src="/assets/flame-outer.png" alt="" aria-hidden className="flame-layer flame-outer" />
      <img src="/assets/flame-inner.png" alt="" aria-hidden className="flame-layer flame-inner" />
      <span className="sr-only">Chama Manutentudo Gás</span>
    </span>
    <span className="leading-none">
      <span className="block font-display text-[25px] font-extrabold uppercase tracking-wide text-[#F7941D]">
        Manutentudo
      </span>
      <span className="mt-0.5 block font-display text-[17px] font-extrabold uppercase tracking-[0.3em] text-[#E6292C]">
        Gás
      </span>
    </span>
  </a>
);
